import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FacebookPostsComponent } from './Components/facebook-posts/facebook-posts.component';


export const facebookRouting: Routes = [
  {
    path: '',
    component: FacebookPostsComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(facebookRouting)],
  exports: [RouterModule],
})
export class FacebookRoutingModule {}
